module.exports = __webpack_public_path__ + "img/agentstudio-screens.2b45032b.png";